import { render, staticRenderFns } from "./ReceptionDeliveryView.vue?vue&type=template&id=37642a2e&scoped=true&"
import script from "./ReceptionDeliveryView.vue?vue&type=script&lang=ts&"
export * from "./ReceptionDeliveryView.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionDeliveryView.vue?vue&type=style&index=0&id=37642a2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37642a2e",
  null
  
)

export default component.exports